import { useQuery } from '@apollo/client';

import { GET_ADVERTISER_SIGNUP_DATE } from '@affiliates/queries';
import { GetAdvertiserSignupDate } from '@affiliates/queries/types/GetAdvertiserSignupDate';

export const useGetAdvertiserSignupDate = () => useQuery<GetAdvertiserSignupDate>(GET_ADVERTISER_SIGNUP_DATE);
